import '@fontsource-variable/manrope';
import './design/tokens.css';
import './design/base.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router';

import { routes } from './app/routes.tsx';
import { env, googleMapsKey, googleMapsMapId } from './config/env.ts';
import { DataProvider } from './data/DataContext.tsx';
import { createFirebaseDataLayer } from './data/firebase/index.ts';
import { ThemeProvider } from './design/theme.tsx';
import { AccountProvider } from './features/account/AccountContext.tsx';
import { CartProvider } from './features/cart/CartContext.tsx';
import { ActivityProvider } from './features/activity/ActivityContext.tsx';
import { LocationProvider } from './features/location/LocationContext.tsx';
import { PresenceProvider } from './features/social/Presence.tsx';
import { createGoogleMaps } from './platform/maps/google/index.ts';
import { unavailableMaps } from './platform/maps/index.ts';
import { MapsProvider } from './platform/maps/MapsContext.tsx';

const data = createFirebaseDataLayer(env);
const maps = googleMapsKey ? createGoogleMaps({ apiKey: googleMapsKey, mapId: googleMapsMapId }) : unavailableMaps;
const router = createBrowserRouter(routes);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <DataProvider data={data}>
        <AccountProvider>
          <PresenceProvider>
            <CartProvider>
              <MapsProvider maps={maps}>
                <LocationProvider>
                  <ActivityProvider>
                    <RouterProvider router={router} />
                  </ActivityProvider>
                </LocationProvider>
              </MapsProvider>
            </CartProvider>
          </PresenceProvider>
        </AccountProvider>
      </DataProvider>
    </ThemeProvider>
  </StrictMode>,
);
